export const EmployeesStatus = () => {
    return [
        {value: "manager", label: "Manager"},
        {value: "project_lead", label: "Project Manager"},
        {value: "employee", label: "Employee"},
    ]
}